import {
  ENVIAR_CONTACTO,
  ENVIAR_CONTACTO_SUCCESS,
  ENVIAR_CONTACTO_FAIL,
} from "../actions/types";

const initialState = {
  isLoading: false,
  limpiarFormulario: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ENVIAR_CONTACTO:
      return {
        ...state,
        isLoading: true,
      };
    case ENVIAR_CONTACTO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        limpiarFormulario: true,
      };
    case ENVIAR_CONTACTO_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}
